import type { RedcatAnalyticsStore } from '../types/store';
import { RestrictedActionTrackEventName } from '../types/restrictedAction';
import type { RestrictedActionTrackEvent } from '../types/events/track';
import { IN_DEVELOPMENT } from '../../constants';

export const trackRestrictedActionBlocked = (
  track: RedcatAnalyticsStore['track'],
  { actionAttempted, blockReason }: { actionAttempted: string; blockReason: string },
) => {
  const event: RestrictedActionTrackEvent = {
    name: RestrictedActionTrackEventName.Blocked,
    properties: {
      action_attempted: actionAttempted,
      block_reason: blockReason,
    },
  };

  if (IN_DEVELOPMENT) {
    // eslint-disable-next-line no-console
    console.log(`[analytics] ${RestrictedActionTrackEventName.Blocked}`, event.properties);
  }

  track(event);
};
